import React, { useState } from 'react';
import TransitionLink from 'gatsby-plugin-transition-link'

function FadeLink({to, className, children, duration = 0.4, delay = 0.4}) {
    return (<TransitionLink to={to} exit={{length: duration}} entry={{delay: delay}} className={className}>
        {children}
    </TransitionLink>);
}

export default FadeLink;